export default function gradeOptionEdit() {
    return {
        gradeChangeOptionSchedules: [],     
        passedSerialId:'',
        peopleCodeId:'',
        showErrorMesage: false,
        message: '',
        successMessage: '',
        selectedGradeOptionSchedules: { title: '', serialId: '', gradeOption: '' },
        passedGradeChangeOptionSchedules: [],
        onLoadGradeOptionSchedules: { title: '', serialId: '', gradeOption: '' },
        onLoadPassedGradeChangeOptionSchedules: [],
        academicYear: '',
        academicTerm: '',
        serialId: '',
        selectedGradeOption: '',
        updatedTitles: '',
        errorCount: 0,
        isSuccessMessage: false,
        isOnChange: false,
        isOnLoad: false,
        removeSerialId(serialId) {
            return serialId.replace(/\(\d+\)/, ''); // Remove text inside parentheses
        },
        formatEventId(eventId) {
            if (eventId != null) {
                return eventId.replace("_", " ");
            }
        },
        bindgradeChangeOptionSchedules() {
            this.isOnLoad = true;
            this.isOnChange = false;
            this.onLoadPassedGradeChangeOptionSchedules = [];
            this.passedGradeChangeOptionSchedules = [];
            fetch('/api/StudentAPI/GetGradeOptionsSchedules', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined) {
                        Array.prototype.push.apply(this.gradeChangeOptionSchedules, response.gradeChangeOptionSchedules);
                       

                    } else {
                        this.isSuccessMessage = false;
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        resetData() {
            this.message = "";
            this.gradeChangeOptionSchedules = [];
            this.bindgradeChangeOptionSchedules();
        },
     
        init() {
            this.gradeChangeOptionSchedules = [];
            this.bindgradeChangeOptionSchedules();
        },
       
        updateGradeOptions() {
            if (this.gradeChangeOptionSchedules.length > 0) {
                for (var i = 0; i < this.gradeChangeOptionSchedules.length; i++) {
                    fetch('/api/StudentAPI/UpdateGradeOptions', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            AcademicYear: this.gradeChangeOptionSchedules[i].academicYear,
                            AcademicTerm: this.gradeChangeOptionSchedules[i].academicTerm,
                            SerialId: this.gradeChangeOptionSchedules[i].serialId,
                            GradeOption: this.gradeChangeOptionSchedules[i].selectedGradeOption,
                        })
                    })
                        .then(response => {
                            if (response.ok) {
                                return response.json()
                            }
                        }).then(response => {

                            if (response.isSuccess) {
                                this.isSuccessMessage = true;
                                this.message = "Grade Options updated successfully.";
                               
                            } else {
                                this.isSuccessMessage = false;
                                this.message = "An unknown error has occurred. Please try again later."
                            }

                        });
                }
            
            }
            
         
        },
        

    }
}